module.exports = __webpack_public_path__ + "static/media/no_files.b16494d0.svg";